module.exports = __webpack_public_path__ + "b6f98e666911a56ad260ec675481c3b2.MP3";